import { render, staticRenderFns } from "./ApprenticeshipInformation.vue?vue&type=template&id=f6f5839e"
import script from "./ApprenticeshipInformation.vue?vue&type=script&lang=js"
export * from "./ApprenticeshipInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports